import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MatSnackBar, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {Event} from '@service/enum/consent-enum';
import {SelectedProductModel} from '@service/models/common-service-model/common-application-service.model';
import {HttpErrorResponse} from '@angular/common/http';
import {SnackbarComponent} from '@core/_shared/snackbar/snackbar.component';
import moment from 'moment/moment';

function _window() {
    return window;
}

@Injectable({
    providedIn: 'root'
})
export class SharedService {

    showScreenLoader: BehaviorSubject<{ showLoader: boolean, loadingText?: string }>;
    stepperStep: BehaviorSubject<number>;
    selectedData: BehaviorSubject<SelectedProductModel>;

    constructor(private _matSnackBar: MatSnackBar) {
        this.showScreenLoader = new BehaviorSubject({showLoader: false, loadingText: ''});
        this.selectedData = new BehaviorSubject(new SelectedProductModel);
        this.stepperStep = new BehaviorSubject(1);
    }

    /**
     *
     * @param message string
     * @param action
     * @param duration millisecond number
     * @param position 'top' | 'bottom'
     */
    showNotification(message: string, action: Event = Event.Warning, duration = 4000, position: MatSnackBarVerticalPosition = 'top') {
        this._matSnackBar.openFromComponent(SnackbarComponent, {
            data: {
                message,
                action
            },
            verticalPosition: position,
            duration: duration,
            panelClass: action.toLowerCase() + '-snackbar'
        });
    }

    /**
     * To hide the toster
     */
    hideNotification() {
        if (this._matSnackBar) {
            this._matSnackBar.dismiss();
        }
    }

    /**
     * Show Global Loader
     * @param loadingText
     */
    showLoader(loadingText: string = '') {
        this.showScreenLoader.next({showLoader: true, loadingText});
    }

    /**
     * Hide Global Loader
     */
    hideLoader() {
        this.showScreenLoader.next({showLoader: false, loadingText: ''});
    }

    /**
     * Set Stepper Step
     */
    setStepper(step) {
        this.stepperStep.next(step);
    }

    /**
     * Convert currency formet to number
     */
    convertNumber(string: string) {
        if (!string) { return; }
        return Number(string.toString().replace(/([\s,€()_-])+/g, ''));
    }

    /**
     * handle Error
     * @param error
     */
    handleError(error: HttpErrorResponse) {
        console.log(error);
        if (error.status === 0) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(
                `Backend returned code ${error.status}, body was: `, error.error);
        }
        // Return an observable with a user-facing error message.
        this.showNotification(error.error.details || 'Something went wrong, Please try again later');
    }

    isMobile() {
        // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(_window().navigator.userAgent);
        const userAgent = _window().navigator.userAgent;
        const navigator = _window().navigator;

        // 1. Traditional mobile/phone UAs (includes older iPads)
        const isPhoneOrOldTablet = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|iPad/i.test(userAgent);

        // 2. Modern iPadOS detection replacement using the UA string check:
        // - UA string contains "Macintosh" (mimicking a desktop Mac)
        // - AND the device has multitouch capability (isolates it from a real Mac desktop)
        const isModernIPad = (
            /Macintosh/.test(userAgent) &&
            navigator.maxTouchPoints > 1
        );

        return isPhoneOrOldTablet || isModernIPad;
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }

    calculateAge(dob) {
        return moment().diff(moment(dob), 'years');
    }
}
